import { MultiSelectChangeEvent } from "primereact/multiselect";
import { TypeCodeToGradingAreaMapping } from "../../config/GradingAreaMapping";
import { useCallback } from "react";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";

export const DefectCodeFilter = (options: ColumnFilterElementTemplateOptions) => {
    const codeOptions = TypeCodeToGradingAreaMapping.map((code) => ({ label: code.longName, value: code.typeCode }))

    const onChange = useCallback((event: MultiSelectChangeEvent) => (
        options.filterApplyCallback(event.value)
    ), [options]);

    return (
        <Dropdown
            value={options.value}
            options={codeOptions}
            onChange={onChange}
            filter
            showClear
            placeholder="Search by Defect Area"
            scrollHeight="400px"
        />
    );
};

